import bg from '../images/bg.png';
import chef from '../images/chef.png';
import G from '../images/G.png';
import gallery01 from '../images/gallery01.png';
import gallery02 from '../images/gallery02.png';
import gallery03 from '../images/gallery03.png';
import gallery04 from '../images/gallery04.png';
import knife from '../images/knife.png';
import logo from '../images/logo.png';
import menu from '../images/menu.png';
import overlaybg from '../images/overlaybg.png';
import spoon from '../images/spoon.svg';
import welcome from '../images/welcome.png';
import findus from '../images/findus.png';
import laurels from '../images/laurels.png';
import award01 from '../images/award01.png';
import award02 from '../images/award02.png';
import award03 from '../images/award03.png';
import award05 from '../images/award05.png';
import sign from '../images/sign.png';
import quote from '../images/quote.png';
import gericht from '../images/gericht.png';

export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
};
